import React, { useEffect } from 'react'
import {
    Switch,
    Route,
} from 'react-router-dom'

import _ from 'lodash'
import { gql, useQuery } from '@apollo/client'

import useAppContext from 'common/context'

// Loading
import Loadable from 'react-loadable'
import Loading from 'common/components/loading/app'

// Modules
const Main = Loadable({
    loader: () => import('./app/index.js'),
    loading: Loading,
})

const Admin = Loadable({
    loader: () => import('admin'),
    loading: Loading,
})

const Auth = Loadable({
    loader: () => import('auth'),
    loading: Loading,
})

const QUERY_DATA = gql`
    query data {
        user {
            id
            admin
        }
        cart {
            items {
                id
            }
        }
        states {
            id
		    name
	    }
        countries {
            id
            name
        }
    }
`

function App() {
    const { setUser, setCart, setStates, setCountries, setReloadData } = useAppContext()

    const { data, loading = true, refetch } = useQuery(QUERY_DATA)

    useEffect(() => {
        setUser(_.get(data, 'user', null))
        setCart(_.get(data, 'cart', { items: [] }))
        setStates(_.get(data, 'states', []))
        setCountries(
            _.orderBy(
                _.get(data, 'countries', []),
                (value) => value.id !== 'US'
            )
        )
    }, [data, setUser, setCart, setStates, setCountries])

    useEffect(() => {
        setReloadData(() => {
            return refetch
        })
    }, [setReloadData, refetch])

    return (
        <>
            {loading && <Loading />}
            {!loading &&
                <Switch>
                    <Route path="/auth" component={Auth} />
                    <Route path="/admin" component={Admin} />
                    <Route path="/" component={Main} />
                </Switch>
            }
        </>
    )
}

export default App

